import React from 'react'

const ExpandIcon = ({ color = "#fff", style }) => {
    return (
        <svg id="expand_more_black_24dp_1_" style={style} data-name="expand_more_black_24dp (1)" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <path id="Path_204228" data-name="Path 204228" d="M24,24H0V0H24Z" fill="none" opacity="0.87" />
            <path id="Path_204229" data-name="Path 204229" d="M16.59,8.59,12,13.17,7.41,8.59,6,10l6,6,6-6Z" fill={color} />
        </svg>
    )
}

export default ExpandIcon